export enum BulkShipmentStatusValue {
  DRAFT = "36224f48-40ff-4272-803b-8210ac70c942",
  PUBLISHED = "5330b63b-538a-4daf-ba0c-bb573f3a0eb4",
}
